<div class="w-full h-[400px] sm:h-[680px] bg-center bg-no-repeat bg-cover"
    style="background-image: url('images/landing/backgrounds/team.png')">
    <div class="w-full h-full flex items-end justify-center pb-[100px] sm:pb-[182px]">
        <div class="flex flex-col items-center">
            <img src="images/landing/about-team.svg" alt="about the team" class="h-[40px] mb-[18px]" />
            <app-button buttonText="explore" (click)="goToTeam()"></app-button>
        </div>
    </div>
</div>